const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
import { Button, Icon } from '@alifd/next';
import { baseUrl } from '../../utils';
const exportUrl = `${baseUrl}/modules/commExcel/export`;
const ExportExcelButton = ({ tableDataSource, columns, tableName, }) => {
    const handleExport = async () => {
        const res = await fetch(exportUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${window.token || localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                columns: columns.map(item => ({
                    title: typeof item.title === 'string' ? item.title : item.title?.props?.children[0],
                    dataIndex: item.dataIndex,
                })),
                tableName: tableName || '',
                data: tableDataSource,
            }),
        });
        if (!res.ok) {
            throw new Error(`导出失败: ${res.status} ${res.statusText}`);
        }
        const blob = await res.blob();
        const contentDisposition = res.headers.get('Content-Disposition');
        let fileName = 'export.xls';
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?/i);
            if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1];
            }
        }
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = decodeURIComponent(fileName);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }, 100);
    };
    return (createElement(Button, { type: "primary", onClick: handleExport },
        createElement(Icon, { type: "download" }),
        " \u5BFC\u51FA"));
};
export default ExportExcelButton;
